<template>
  <div class="container">

	<div id="detailView" class="sixteen columns" >
	
        <div style="width:100%;max-width:422px; display:inline-block;margin-right:5px;">
            <p style="font-size:20px; text-align:center;">desktop</p>
        <img src="/projects/vipp/images/screen1.jpg"/>
        </div>
        
            <div style="width:100%;max-width:340px; display:inline-block;margin-right:5px;">
            <p style="font-size:20px; text-align:center;">tablet</p>
        <img src="/projects/vipp/images/ipad-1.jpg"/>
        </div>
		       <div style="width:100%;max-width:157px; display:inline-block;">
            <p style="font-size:20px; text-align:center;">mobile</p>
        <img src="/projects/vipp/images/phone-1-crop-u87.jpg"/>
        </div>
               <div style="width:100%;max-width:937px; display:inline-block;">
     
        <img src="/projects/vipp/images/presentation-shop.gif"/>
        </div>
        
        
              <div style="width:100%;max-width:402px; display:inline-block;margin-right:17px;">
          
        <img src="/projects/vipp/images/screen2.jpg"/>
        </div>
        
            <div style="width:100%;max-width:346px; display:inline-block;margin-right:9px;">
   
        <img src="/projects/vipp/images/ipad-2.jpg"/>
        </div>
		       <div style="width:100%;max-width:157px; display:inline-block;">

        <img src="/projects/vipp/images/phone-2-crop-u120.jpg"/>
        </div>
        
        
            <div style="width:100%;max-width:937px; display:inline-block; background-color:#3D88BB;">
     
        <img style="width:100% height:auto; margin:auto; display:block;"src="images/submenu-motion-new.gif"/ >
        </div>
              <div style="width:100%;max-width:590px; display:inline-block;margin-right:5px;">
   
        <img src="/projects/vipp/images/screen3.jpg"/>
        </div>
        
         <div style="width:100%;max-width:339px; display:inline-block;">
   
        <img src="/projects/vipp/images/ipad-3.jpg"/>
        </div>
          <div style="width:100%;max-width:937px; display:inline-block;">
     
        <img src="/projects/vipp/images/menu.gif"/>
        </div>
	</div>

		
</div><!-- container -->
</template>

<script>
export default {
  name: "Vipp",
  props: {}
};
</script>


